import {signInWithRedirect} from "aws-amplify/auth"

export default async function ssoLogin(provider) {
    return await signInWithRedirect({provider: {custom: provider}})
}